
import React from 'react'
import SbEditable from 'storyblok-react'
import Label from 'src/components/Label'
import Heading from 'src/components/Heading'
import Button from 'src/components/Button'
import { LabelColour } from 'src/utils/ColourUtilities'
import GetNewsArticles from 'src/utils/GetNewsArticles'
import ArchiveItem from 'src/components/Archives/ArchiveItem'

const ThreeColumnImages = ({blok}) => {
    return (
        <SbEditable content={blok} >
            <div className="py-14 lg:py-20 bg-cloud">
                <div className="max-w-7xl mx-auto px-6">
                    <div className="mx-auto grid grid-cols-1 lg:grid-cols-3 gap-4">
                        <img src={blok?.image_one?.filename} alt={blok?.image_one?.alt} className="w-full h-auto"/>
                        <img src={blok?.image_two?.filename} alt={blok?.image_two?.alt} className="w-full h-auto"/>
                        <img src={blok?.image_three?.filename} alt={blok?.image_three?.alt} className="w-full h-auto"/>
                    </div>
                </div>
            </div>
      </SbEditable>
    )
  };

export default ThreeColumnImages
  